module.exports = __webpack_public_path__ + "static/media/kaokotalk.ce857aeb.svg";